<div>
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="associationsData"
      [disableSelection]="true" [cols]="gridCols" [gridTitle]="false" [pagination]="false" [loadPage]="true">
    </ppl-list-table>
  
  </div>